import Vue from "vue"
import VueRouter from "vue-router"
import { store } from "@/store/stores"
import userService from "@/services/userService"
import { isPublicTdotEntry, publicTdotLocation } from "./tdotEntry"

Vue.use(VueRouter)

const routeFiles = require.context("./routes", false, /.*Routes\.js$/)

let routes = []

routeFiles.keys().forEach((filePath) => {
  const routeModule = routeFiles(filePath)
  routes = [...routes, ...routeModule.default]
})

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach(async (to, from, next) => {
  await store.restored

  // A shared TDOT calendar link must also work without a staff session.
  if (to.name === "guestbookEntry" && isPublicTdotEntry(to,
    !!localStorage.getItem("token") && userService.hasRightArray(["ab_create", "c_create"]))) {
    return next(publicTdotLocation(to))
  }

  // Check if the route requires any specific rights or roles
  const requiresAuth = (to.meta && to.meta.rights) || to.meta.role

  if (requiresAuth) {
    // Check if the user has at least one of the required rights
    const hasRights = userService.hasRightArray(to.meta.rights)

    // Check if the user has at least one of the required roles from the array
    const hasRole = to.meta.role && to.meta.role.some((r) => userService.hasRole(r))

    // If the user has neither the required rights NOR any of the required roles, redirect them.
    if (!hasRights && !hasRole) {
      console.log("Keine Berechtigung -> Weiterleitung nach / (Home).")
      return next({ name: "Home" })
    }
  }

  next() // Proceed with navigation
})

export default router
